module.exports = __webpack_public_path__ + "static/media/ginger.8618a256.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/ginger.jpeg
// module id = 2031
// module chunks = 0